export default "__VITE_ASSET__DKSbg7IB__"